// Arrows.js
import { ArrowRight, ArrowLeft } from "lucide-react";
import "./SlickButtons.css";

export function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <ArrowRight size={24} color="white" />
    </button>
  );
}

export function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <ArrowLeft size={24} color="white" />
    </button>
  );
}
